import { DataIdSchema } from "@/schemas";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { getGroupLoader } from "../../-funtions/loader/group";

export const Route = createFileRoute("/dashboard/chat/group/$id")({
	params: {
		parse: (params) => ({
			id: DataIdSchema.parse(Number(params.id)),
		}),
		stringify: ({ id }) => ({ id: id.toString() }),
	},
	loader: (ctx) => getGroupLoader(ctx.context, ctx.params.id),
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<Outlet />
		</>
	);
}
